import SlotsHeaderContainer from "@/app/components/routes/auth_routes/SlotsScreen/SlotsHeaderContainer";
import { useSingleBookingDetailsAPI } from "@/app/hooks/api_hooks/bookings/useSingleBookingDetailsAPI";
import { useStringConstants } from "@/app/hooks/useStringConstants";
import { useVMSParams } from "@/app/hooks/useVMSParams";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import {
  setOverbookingFlag,
  setRescheduleBookingSummaryData,
  setRescheduleFlag,
  setSlotBookingFilters,
  setSlotsPageReadonly,
} from "@/app_redux/reducers/slices/auth/slots_slice";
import { format } from "date-fns";
import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router";
import { useSearchParams } from "react-router-dom";
import { ISlotsPageProps } from "./interface";

const SlotsPage: React.FC<ISlotsPageProps> = (_props) => {
  /* Will redirect to invalid access when no pet or user is selected */
  // usePlug([UserAndPetSelectedPlug()]);
  const [params, _setparams] = useSearchParams();
  const { slotStatusAvailable } = useStringConstants();
  const { pathname } = useLocation();
  const dispatch = useAppDispatch();

  const fetchBookingDetails = useSingleBookingDetailsAPI();
  useVMSParams();
  useEffect(() => {
    const bookingType = params.get("type");
    const rescheduleBookingId = params.get("rbi");
    if (bookingType === "reschedule") {
      dispatch(setRescheduleFlag(true));
      dispatch(setOverbookingFlag(false));
      dispatch(setRescheduleBookingSummaryData({ data: null }));
      if (rescheduleBookingId) {
        fetchBookingDetails(rescheduleBookingId, true, true).then((bookingDetails) => {
          // Use the previous booking's date only if it is in the future, otherwise today.
          const today = format(new Date(), "yyyy-MM-dd");
          const bookingDate = bookingDetails?.booking_start_date;
          const rescheduleDate = bookingDate && bookingDate > today ? bookingDate : today;
          dispatch(
            setSlotBookingFilters({
              filters: {
                booking_date: rescheduleDate,
                clinic_ids: bookingDetails?.clinic_id ? [bookingDetails.clinic_id] : [],
                location_details: {
                  latitude: "",
                  longitude: "",
                },
                pet_species_id: bookingDetails?.pet_details?.pet_species_type_id,
                service_id: bookingDetails?.service_id,
                staff_ids: [],
                sub_service_id: bookingDetails?.subservice_id,
                city_id: "",
                slot_status: slotStatusAvailable,
              },
            }),
          );
        });
      }
    } else {
      dispatch(setRescheduleFlag(false));
      dispatch(setRescheduleBookingSummaryData({ data: null }));
    }
  }, []);
  useEffect(() => {
    dispatch(setSlotsPageReadonly(false));
  }, []);
  return (
    <>
      {!pathname?.includes("booking-confirmation") && <SlotsHeaderContainer />}
      {/* Render tabs according to the URL and routing */}
      <Outlet />
    </>
  );
};

export default SlotsPage;
